export enum EToastId {
  undiscountableItem = 'undiscountable-item',
}
